import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class DurationTracker {
  constructor() {
    _defineProperty(this, "startTimes", {});
  }
  markTransactionStart(transactionName) {
    this.startTimes[transactionName] = Date.now();
  }
  markTransactionFinish(transactionName) {
    const finishTime = Date.now();
    const startTime = this.startTimes[transactionName] || finishTime;
    const duration = Math.round(finishTime - startTime);
    this.startTimes[transactionName] = 0;
    return duration;
  }
}
//# sourceMappingURL=duration-tracker.js.map